module.exports = __webpack_public_path__ + "front/img/register-kv.24b2a3b5.png";